import React from 'react';
import {Card, CardMedia, CardTitle, CardText, CardActions} from 'material-ui/Card';
import {picdata} from '../../Interfaces/picdata';
import FlatButton from 'material-ui/FlatButton';
import {FormattedDate} from 'react-intl';
import {withStyles, css} from 'withStyles';
import {IWithStyleProps} from 'Interfaces/react-with-style';

interface CardProps {
  date: picdata;
  onClickFlatButton: Function;
}

@withStyles(({ }) => ({
  PictureCard: {
    margin: '20px auto',
    width: '100%',
    display: 'block'
  },
  ImgBox: {
    'height': '600px',
    'width': '100%',
    'background-repeat': 'no-repeat',
    'background-position': '50% 50%',
    'background-size': 'cover',
    'background-origin': 'padding-box',
    'background-attachment': 'scroll',
    'display': 'flex',
    'justify-content': 'center',
    'align-items': 'center',
  },
  Img: {
    'max-height': '100%',
    'max-width': '100%'
  },
  CardActions: {
    'display': 'flex',
    'justify-content': 'space-between',
    'align-items': 'center',
    'height': '36px'
  }
}))
export class PictureCard extends React.Component<CardProps & IWithStyleProps, undefined> {
  render() {
    const {date = {}} = this.props;
    const {标题 = '', 项目名称 = '', 奖项等第 = '', 姓名 = '', 路径 = '', 分类 = '', 日期 = ''} = date;
    return (
      <Card {...css(this.props.styles.PictureCard)}>
        <CardMedia
          overlay={<CardTitle title={标题} subtitle={项目名称 + ' ' + 奖项等第 + ' ' + 姓名} />}
        >
          <div {...css(this.props.styles.ImgBox)}>
            <img src={路径} {...css(this.props.styles.Img)} />
          </div>
        </CardMedia>
        <CardText />
        <CardActions>
          <div {...css(this.props.styles.img)}>
            <span><FlatButton label={分类} onTouchTap={this.props.onClickFlatButton as any} /></span>
            <span>{<FormattedDate value={new Date(日期)} />}</span>
          </div>
        </CardActions>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PictureCard/index.tsx